import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

export interface ICellRendererParamsForPercentAllocation extends ICellRendererParams {
    editMode: () => boolean;
    onBlur: (params: ICellRendererParamsForPercentAllocation) => void;
}

@Component({
    selector: 'Renderer-cell',
    template: `
        @if (params && params.data) {
          <div>
            @if (!params.data.isTotal) {
              <span>
                @if (params.editMode()) {
                  <input
                    type="text"
                    class="form-control"
                    style="width: 100px;"
                    currencyMask
                    [options]="{ allowNegative: false, precision: 4, prefix: '', suffix: '%' }"
                    [(ngModel)]="params.data.displayAllocationPct"
                    (blur)="params.onBlur(params)"
                    >
                }
                @if (!params.editMode()) {
                  <span>{{params.data.allocationPct | percent:'1.4-4'}}</span>
                }
              </span>
            }
            @if (params.data.isTotal) {
              <span>TOTAL:</span>
            }
          </div>
        }
        `,
    standalone: false
})
export class AgGridPercentAllocationCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForPercentAllocation;

    agInit(params: ICellRendererParamsForPercentAllocation): void {
        this.params = params;
    }

    refresh() {
        return false;
    }
}
